import { CurrencyTextField, NumberInput } from '@core/components/Inputs';
import { SelectSimple } from '@core/components/Select';
import { Checkbox, Divider, FormControlLabel, Grid, Tooltip, Typography } from '@material-ui/core';
import SelectCstClassificacaoTributaria from 'app/components/Select/SelectCstClassificacaoTributaria';
import SelectCstSituacaoTributaria from 'app/components/Select/SelectCstSituacaoTributaria';
import empresaApi from 'app/services/api/empresaApi';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';

const TabDadosFiscaisServico = ({ errors }) => {
  const formik = useFormikContext();
  const [empresaIbsCbs, setEmpresaIbsCbs] = useState(false);

  useEffect(() => {
    const carregarEmpresaIbsCbs = async () => {
      try {
        const empresaId = getEmpresaContexto();
        const empresa = await empresaApi.buscar(empresaId);
        const isEmpresaSimplesNacional = empresa?.data?.optanteSimples;
        const isEmpresaSaoPaulo = empresa?.data?.pessoa?.endereco?.cidade?.nome === 'São Paulo';
        const podeHabilitarIbsCbs = !isEmpresaSimplesNacional || (isEmpresaSimplesNacional && isEmpresaSaoPaulo);
        
        if (podeHabilitarIbsCbs && empresa?.data?.ibsCbs) {
          setEmpresaIbsCbs(true);
        } else {
          setEmpresaIbsCbs(false);
        }
      } catch (error) {
        setEmpresaIbsCbs(false);
      }
    };
    carregarEmpresaIbsCbs();
  }, []);

  const retencaoIss = (tipoIss) => {
    return (
      <>
        {tipoIss === 'PERCENTUAL' && (
          <NumberInput
            id="valorIss"
            label="ISS (%)"
            decimalScale={8}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={(values) => {
              return !values.floatValue || values.floatValue <= 100;
            }}
            value={formik.values?.valorIss}
            onChange={(event) => {
              formik.handleChange(event);
              if (event.target.value === undefined) {
                formik.setFieldValue('issRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            touched={!!errors?.valorIss}
            error={errors?.valorIss}
          />
        )}

        {tipoIss === 'VALOR' && (
          <CurrencyTextField
            id="valorIss"
            outputFormat="number"
            decimalCharacter=","
            digitGroupSeparator="."
            maximumValue="999999999"
            minimumValue="0"
            decimalPlaces={2}
            decimalPlacesShownOnBlur={2}
            decimalPlacesShownOnFocus={2}
            error={!!errors?.valorIss}
            touched={!!errors?.valorIss}
            helperText={errors?.valorIss}
            onChange={(e, value) => {
              formik.handleChange({
                target: {
                  id: 'valorIss',
                  value: e.target.value === '' ? '' : value,
                },
              });

              if (e.target.value === undefined || e.target.value === '') {
                formik.setFieldValue('issRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            value={formik.values?.valorIss}
            fullWidth
            variant="outlined"
            label="ISS (R$)"
            hideCurrencySymbol
          />
        )}
      </>
    );
  };

  const retencaoIrrf = (tipoIrrf) => {
    return (
      <>
        {tipoIrrf === 'PERCENTUAL' && (
          <NumberInput
            id="valorIrrf"
            label="IRRF (%)"
            decimalScale={8}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={(values) => {
              return !values.floatValue || values.floatValue <= 100;
            }}
            value={formik.values?.valorIrrf}
            onChange={(event) => {
              formik.handleChange(event);
              if (event.target.value === undefined) {
                formik.setFieldValue('irrfRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            touched={!!errors?.valorIrrf}
            error={errors?.valorIrrf}
          />
        )}

        {tipoIrrf === 'VALOR' && (
          <CurrencyTextField
            id="valorIrrf"
            outputFormat="number"
            decimalCharacter=","
            digitGroupSeparator="."
            maximumValue="999999999"
            minimumValue="0"
            decimalPlaces={2}
            decimalPlacesShownOnBlur={2}
            decimalPlacesShownOnFocus={2}
            error={!!errors?.valorIrrf}
            touched={!!errors?.valorIrrf}
            helperText={errors?.valorIrrf}
            onChange={(e, value) => {
              formik.handleChange({
                target: {
                  id: 'valorIrrf',
                  value: e.target.value === '' ? '' : value,
                },
              });

              if (e.target.value === undefined || e.target.value === '') {
                formik.setFieldValue('irrfRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            value={formik.values?.valorIrrf}
            fullWidth
            variant="outlined"
            label="IRRF (R$)"
            hideCurrencySymbol
          />
        )}
      </>
    );
  };

  const retencaoPis = (tipoPis) => {
    return (
      <>
        {tipoPis === 'PERCENTUAL' && (
          <NumberInput
            id="valorPis"
            label="PIS (%)"
            decimalScale={8}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={(values) => {
              return !values.floatValue || values.floatValue <= 100;
            }}
            value={formik.values?.valorPis}
            onChange={(event) => {
              formik.handleChange(event);
              if (event.target.value === undefined) {
                formik.setFieldValue('pisRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            touched={!!errors?.valorPis}
            error={errors?.valorPis}
          />
        )}

        {tipoPis === 'VALOR' && (
          <CurrencyTextField
            id="valorPis"
            outputFormat="number"
            decimalCharacter=","
            digitGroupSeparator="."
            maximumValue="999999999"
            minimumValue="0"
            decimalPlaces={2}
            decimalPlacesShownOnBlur={2}
            decimalPlacesShownOnFocus={2}
            error={!!errors?.valorPis}
            touched={!!errors?.valorPis}
            helperText={errors?.valorPis}
            onChange={(e, value) => {
              formik.handleChange({
                target: {
                  id: 'valorPis',
                  value: e.target.value === '' ? '' : value,
                },
              });

              if (e.target.value === undefined || e.target.value === '') {
                formik.setFieldValue('pisRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            value={formik.values?.valorPis}
            fullWidth
            variant="outlined"
            label="PIS (R$)"
            hideCurrencySymbol
          />
        )}
      </>
    );
  };

  const retencaoCofins = (tipoCofins) => {
    return (
      <>
        {tipoCofins === 'PERCENTUAL' && (
          <NumberInput
            id="valorCofins"
            label="COFINS (%)"
            decimalScale={8}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={(values) => {
              return !values.floatValue || values.floatValue <= 100;
            }}
            value={formik.values?.valorCofins}
            onChange={(event) => {
              formik.handleChange(event);
              if (event.target.value === undefined) {
                formik.setFieldValue('cofinsRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            touched={!!errors?.valorCofins}
            error={errors?.valorCofins}
          />
        )}

        {tipoCofins === 'VALOR' && (
          <CurrencyTextField
            id="valorCofins"
            outputFormat="number"
            decimalCharacter=","
            digitGroupSeparator="."
            maximumValue="999999999"
            minimumValue="0"
            decimalPlaces={2}
            decimalPlacesShownOnBlur={2}
            decimalPlacesShownOnFocus={2}
            error={!!errors?.valorCofins}
            touched={!!errors?.valorCofins}
            helperText={errors?.valorCofins}
            onChange={(e, value) => {
              formik.handleChange({
                target: {
                  id: 'valorCofins',
                  value: e.target.value === '' ? '' : value,
                },
              });

              if (e.target.value === undefined || e.target.value === '') {
                formik.setFieldValue('cofinsRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            value={formik.values?.valorCofins}
            fullWidth
            variant="outlined"
            label="COFINS (R$)"
            hideCurrencySymbol
          />
        )}
      </>
    );
  };

  const retencaoInss = (tipoInss) => {
    return (
      <>
        {tipoInss === 'PERCENTUAL' && (
          <NumberInput
            id="valorInss"
            label="INSS (%)"
            decimalScale={8}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={(values) => {
              return !values.floatValue || values.floatValue <= 100;
            }}
            value={formik.values?.valorInss}
            onChange={(event) => {
              formik.handleChange(event);
              if (event.target.value === undefined) {
                formik.setFieldValue('inssRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            touched={!!errors?.valorInss}
            error={errors?.valorInss}
          />
        )}

        {tipoInss === 'VALOR' && (
          <CurrencyTextField
            id="valorInss"
            outputFormat="number"
            decimalCharacter=","
            digitGroupSeparator="."
            maximumValue="999999999"
            minimumValue="0"
            decimalPlaces={2}
            decimalPlacesShownOnBlur={2}
            decimalPlacesShownOnFocus={2}
            error={!!errors?.valorInss}
            touched={!!errors?.valorInss}
            helperText={errors?.valorInss}
            onChange={(e, value) => {
              formik.handleChange({
                target: {
                  id: 'valorInss',
                  value: e.target.value === '' ? '' : value,
                },
              });

              if (e.target.value === undefined || e.target.value === '') {
                formik.setFieldValue('inssRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            value={formik.values?.valorInss}
            fullWidth
            variant="outlined"
            label="INSS (R$)"
            hideCurrencySymbol
          />
        )}
      </>
    );
  };

  const retencaoCsll = (tipoCsll) => {
    return (
      <>
        {tipoCsll === 'PERCENTUAL' && (
          <NumberInput
            id="valorCsll"
            label="CSLL (%)"
            decimalScale={8}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={(values) => {
              return !values.floatValue || values.floatValue <= 100;
            }}
            value={formik.values?.valorCsll}
            onChange={(event) => {
              formik.handleChange(event);
              if (event.target.value === undefined) {
                formik.setFieldValue('csllRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            touched={!!errors?.valorCsll}
            error={errors?.valorCsll}
          />
        )}

        {tipoCsll === 'VALOR' && (
          <CurrencyTextField
            id="valorCsll"
            outputFormat="number"
            decimalCharacter=","
            digitGroupSeparator="."
            maximumValue="999999999"
            minimumValue="0"
            decimalPlaces={2}
            decimalPlacesShownOnBlur={2}
            decimalPlacesShownOnFocus={2}
            error={!!errors?.valorInss}
            touched={!!errors?.valorCsll}
            helperText={errors?.valorCsll}
            onChange={(e, value) => {
              formik.handleChange({
                target: {
                  id: 'valorCsll',
                  value: e.target.value === '' ? '' : value,
                },
              });

              if (e.target.value === undefined || e.target.value === '') {
                formik.setFieldValue('csllRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            value={formik.values.valorCsll}
            fullWidth
            variant="outlined"
            label="CSLL (R$)"
            hideCurrencySymbol
          />
        )}
      </>
    );
  };

  const retencaoIbs = (tipoIbs) => {
    return (
      <>
        {tipoIbs === 'PERCENTUAL' && (
          <NumberInput
            id="valorIbs"
            label="IBS Estadual (%)"
            decimalScale={8}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={(values) => {
              return !values.floatValue || values.floatValue <= 100;
            }}
            value={formik.values?.valorIbs}
            onChange={(event) => {
              formik.handleChange(event);
              if (event.target.value === undefined) {
                formik.setFieldValue('ibsRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            touched={!!errors?.valorIbs}
            error={errors?.valorIbs}
          />
        )}

        {/* {tipoIbs === 'VALOR' && (
            <CurrencyTextField
              id="valorIbs"
              outputFormat="number"
              decimalCharacter=","
              digitGroupSeparator="."
              maximumValue="999999999"
              minimumValue="0"
              decimalPlaces={2}
              decimalPlacesShownOnBlur={2}
              decimalPlacesShownOnFocus={2}
              error={!!errors?.valorIbs}
              touched={!!errors?.valorIbs}
              helperText={errors?.valorIbs}
              onChange={(e, value) => {
                formik.handleChange({
                  target: {
                    id: 'valorIbs',
                    value: e.target.value === '' ? '' : value,
                  },
                });
  
                if (e.target.value === undefined || e.target.value === '') {
                  formik.setFieldValue('ibsRetidoNaFonte', false);
                }
              }}
              onBlur={formik.handleBlur}
              value={formik.values?.valorIbs}
              fullWidth
              variant="outlined"
              label="IBS (R$)"
              hideCurrencySymbol
              required
            />
          )} */}
      </>
    );
  };

  const retencaoIbsMunicipal = (tipoIbsMunicipal) => {
    return (
      <>
        {tipoIbsMunicipal === 'PERCENTUAL' && (
          <NumberInput
            id="valorIbsMunicipal"
            label="IBS Municipal (%)"
            decimalScale={8}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={(values) => {
              return !values.floatValue || values.floatValue <= 100;
            }}
            value={formik.values?.valorIbsMunicipal}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            touched={!!errors?.valorIbsMunicipal}
            error={errors?.valorIbsMunicipal}
          />
        )}
      </>
    );
  };

  const retencaoCbs = (tipoCbs) => {
    return (
      <>
        {tipoCbs === 'PERCENTUAL' && (
          <NumberInput
            id="valorCbs"
            label="CBS (%)"
            decimalScale={8}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={(values) => {
              return !values.floatValue || values.floatValue <= 100;
            }}
            value={formik.values?.valorCbs}
            onChange={(event) => {
              formik.handleChange(event);
              if (event.target.value === undefined) {
                formik.setFieldValue('cbsRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            touched={!!errors?.valorCbs}
            error={errors?.valorCbs}
          />
        )}

        {/* {tipoCbs === 'VALOR' && (
            <CurrencyTextField
              id="valorCbs"
              outputFormat="number"
              decimalCharacter=","
              digitGroupSeparator="."
              maximumValue="999999999"
              minimumValue="0"
              decimalPlaces={2}
              decimalPlacesShownOnBlur={2}
              decimalPlacesShownOnFocus={2}
              error={!!errors?.valorCbs}
              touched={!!errors?.valorCbs}
              helperText={errors?.valorCbs}
              onChange={(e, value) => {
                formik.handleChange({
                  target: {
                    id: 'valorCbs',
                    value: e.target.value === '' ? '' : value,
                  },
                });
  
                if (e.target.value === undefined || e.target.value === '') {
                  formik.setFieldValue('cbsRetidoNaFonte', false);
                }
              }}
              onBlur={formik.handleBlur}
              value={formik.values?.valorCbs}
              fullWidth
              variant="outlined"
              label="CBS (R$)"
              hideCurrencySymbol
              required
            />
          )} */}
      </>
    );
  };

  const retencaoIs = (tipoIs) => {
    return (
      <>
        {tipoIs === 'PERCENTUAL' && (
          <NumberInput
            id="valorIs"
            label="IS (%)"
            decimalScale={8}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={(values) => {
              return !values.floatValue || values.floatValue <= 100;
            }}
            value={formik.values?.valorIs}
            onChange={(event) => {
              formik.handleChange(event);
              if (event.target.value === undefined) {
                formik.setFieldValue('isRetidoNaFonte', false);
              }
            }}
            onBlur={formik.handleBlur}
            touched={!!errors?.valorIs}
            error={errors?.valorIs}
          />
        )}

        {/* {tipoIs === 'VALOR' && (
            <CurrencyTextField
              id="valorIs"
              outputFormat="number"
              decimalCharacter=","
              digitGroupSeparator="."
              maximumValue="999999999"
              minimumValue="0"
              decimalPlaces={2}
              decimalPlacesShownOnBlur={2}
              decimalPlacesShownOnFocus={2}
              error={!!errors?.valorIs}
              touched={!!errors?.valorIs}
              helperText={errors?.valorIs}
              onChange={(e, value) => {
                formik.handleChange({
                  target: {
                    id: 'valorIs',
                    value: e.target.value === '' ? '' : value,
                  },
                });
  
                if (e.target.value === undefined || e.target.value === '') {
                  formik.setFieldValue('isRetidoNaFonte', false);
                }
              }}
              onBlur={formik.handleBlur}
              value={formik.values?.valorIs}
              fullWidth
              variant="outlined"
              label="IS (R$)"
              hideCurrencySymbol
              required
            />
          )} */}
      </>
    );
  };

  const campoCstClassificacaoTributaria = () => {
    const situacaoTributariaPreenchida = !!formik.values?.cstSituacaoTributaria?.id;

    const selectCstClassificacao = (
      <SelectCstClassificacaoTributaria
        id="cstClassificacaoTributaria"
        name="cstClassificacaoTributaria"
        label="Código de classificação tributária"
        value={formik.values?.cstClassificacaoTributaria}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        disabled={!formik.values?.cstSituacaoTributaria?.id}
        required={false}
        idSituacao={formik.values?.cstSituacaoTributaria?.idSituacao}
        touched={!!errors?.cstClassificacaoTributaria}
        error={errors?.cstClassificacaoTributaria}
      />
    );

    if (situacaoTributariaPreenchida) {
      return selectCstClassificacao;
    }

    return (
      <Tooltip title="O campo será habilitado quando o código de situação tributária for informada" placement="top">
        <div style={{ width: '100%' }}>{selectCstClassificacao}</div>
      </Tooltip>
    );
  };

  return (
    <Grid container spacing={3} className="mt-16">
      <Grid item xs={12} sm={12} md={12} lg={1} xl={1}>
        <SelectSimple
          id="tipoIss"
          label="Tipo"
          value={formik.values?.tipoIss}
          fullWidth
          onChange={(event) => {
            formik.handleChange(event);
            formik.setFieldValue('valorIss', undefined);
            formik.setFieldValue('issRetidoNaFonte', false);
          }}
          onBlur={formik.handleBlur}
          defaultValue="PERCENTUAL"
          options={[
            { title: '%', id: 'PERCENTUAL' },
            { title: 'R$', id: 'VALOR' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
        {retencaoIss(formik.values?.tipoIss)}
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              id="issRetidoNaFonte"
              name="issRetidoNaFonte"
              value={formik.values?.issRetidoNaFonte}
              checked={formik.values?.issRetidoNaFonte}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={formik.values?.valorIss === undefined}
            />
          }
          label="Retenção de ISS pelo cliente"
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={1} xl={1}>
        <SelectSimple
          id="tipoIrrf"
          label="Tipo"
          value={formik.values?.tipoIrrf}
          fullWidth
          onChange={(event) => {
            formik.handleChange(event);
            formik.setFieldValue('valorIrrf', undefined);
            formik.setFieldValue('irrfRetidoNaFonte', false);
          }}
          onBlur={formik.handleBlur}
          defaultValue="PERCENTUAL"
          options={[
            { title: '%', id: 'PERCENTUAL' },
            { title: 'R$', id: 'VALOR' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
        {retencaoIrrf(formik.values?.tipoIrrf)}
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              id="irrfRetidoNaFonte"
              name="irrfRetidoNaFonte"
              value={formik.values?.irrfRetidoNaFonte}
              checked={formik.values?.irrfRetidoNaFonte}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={formik.values?.valorIrrf === undefined}
            />
          }
          label="Retenção de IRRF pelo cliente"
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={1} xl={1}>
        <SelectSimple
          id="tipoPis"
          label="Tipo"
          value={formik.values?.tipoPis}
          fullWidth
          onChange={(event) => {
            formik.handleChange(event);
            formik.setFieldValue('valorPis', undefined);
            formik.setFieldValue('pisRetidoNaFonte', false);
          }}
          onBlur={formik.handleBlur}
          defaultValue="PERCENTUAL"
          options={[
            { title: '%', id: 'PERCENTUAL' },
            { title: 'R$', id: 'VALOR' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
        {retencaoPis(formik.values?.tipoPis)}
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              id="pisRetidoNaFonte"
              name="pisRetidoNaFonte"
              value={formik.values?.pisRetidoNaFonte}
              checked={formik.values?.pisRetidoNaFonte}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={formik.values?.valorPis === undefined}
            />
          }
          label="Retenção de PIS pelo cliente"
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={1} xl={1}>
        <SelectSimple
          id="tipoCofins"
          label="Tipo"
          value={formik.values?.tipoCofins}
          fullWidth
          onChange={(event) => {
            formik.handleChange(event);
            formik.setFieldValue('valorCofins', undefined);
            formik.setFieldValue('cofinsRetidoNaFonte', false);
          }}
          onBlur={formik.handleBlur}
          defaultValue="PERCENTUAL"
          options={[
            { title: '%', id: 'PERCENTUAL' },
            { title: 'R$', id: 'VALOR' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
        {retencaoCofins(formik.values?.tipoCofins)}
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              id="cofinsRetidoNaFonte"
              name="cofinsRetidoNaFonte"
              value={formik?.values?.cofinsRetidoNaFonte}
              checked={formik?.values?.cofinsRetidoNaFonte}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={formik.values?.valorCofins === undefined}
            />
          }
          label="Retenção de COFINS pelo cliente"
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={1} xl={1}>
        <SelectSimple
          id="tipoInss"
          label="Tipo"
          value={formik.values?.tipoInss}
          fullWidth
          onChange={(event) => {
            formik.handleChange(event);
            formik.setFieldValue('valorInss', undefined);
            formik.setFieldValue('inssRetidoNaFonte', false);
          }}
          onBlur={formik.handleBlur}
          defaultValue="PERCENTUAL"
          options={[
            { title: '%', id: 'PERCENTUAL' },
            { title: 'R$', id: 'VALOR' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
        {retencaoInss(formik.values?.tipoInss)}
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              id="inssRetidoNaFonte"
              name="inssRetidoNaFonte"
              value={formik.values?.inssRetidoNaFonte}
              checked={formik.values?.inssRetidoNaFonte}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={formik.values?.valorInss === undefined}
            />
          }
          label="Retenção de INSS pelo cliente"
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={1} xl={1}>
        <SelectSimple
          id="tipoCsll"
          label="Tipo"
          value={formik.values?.tipoCsll}
          fullWidth
          onChange={(event) => {
            formik.handleChange(event);
            formik.setFieldValue('valorCsll', undefined);
            formik.setFieldValue('csllRetidoNaFonte', false);
          }}
          onBlur={formik.handleBlur}
          defaultValue="PERCENTUAL"
          options={[
            { title: '%', id: 'PERCENTUAL' },
            { title: 'R$', id: 'VALOR' },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
        {retencaoCsll(formik.values?.tipoCsll)}
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              id="csllRetidoNaFonte"
              name="csllRetidoNaFonte"
              value={formik.values?.csllRetidoNaFonte}
              checked={formik.values?.csllRetidoNaFonte}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={formik.values?.valorCsll === undefined}
            />
          }
          label="Retenção de CSLL pelo cliente"
        />
      </Grid>

      {empresaIbsCbs && (
        <>
          <Grid item xs={12}>
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>
              IBS / CBS - Reforma Tributária
            </Typography>
            <Divider />
          </Grid>

          <Grid item xs={6}>
            <SelectCstSituacaoTributaria
              id="cstSituacaoTributaria"
              name="cstSituacaoTributaria"
              value={formik.values?.cstSituacaoTributaria}
              onChange={(e) => {
                formik.handleChange(e);
                formik.setFieldValue('cstClassificacaoTributaria', null);
                formik.setFieldValue('cstSituacaoTributaria.idSituacao', e.target.value?.idSituacao);
              }}
              onBlur={formik.handleBlur}
              label="Código de situação tributária (CST)"
              touched={!!errors?.cstSituacaoTributaria}
              error={errors?.cstSituacaoTributaria}
              required={false}
            />
          </Grid>
          <Grid item xs={6}>
            {campoCstClassificacaoTributaria()}
          </Grid>

          {/* <Grid item xs={12} sm={12} md={12} lg={1} xl={1}>
            <SelectSimple
              id="tipoIbs"
              label="Tipo"
              value={formik.values??.tipoIbs}
              fullWidth
              onChange={(event) => {
                formik.handleChange(event);
                formik.setFieldValue('valorIbs', undefined);
                formik.setFieldValue('ibsRetidoNaFonte', false);
              }}
              onBlur={formik.handleBlur}
              defaultValue="PERCENTUAL"
              options={[
                { title: '%', id: 'PERCENTUAL' },
                { title: 'R$', id: 'VALOR' },
              ]}
            />
          </Grid> */}
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
            {retencaoIbs(formik.values?.tipoIbs)}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
            {retencaoIbsMunicipal(formik.values?.tipoIbsMunicipal || 'PERCENTUAL')}
          </Grid>
          {/* <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  id="ibsRetidoNaFonte"
                  name="ibsRetidoNaFonte"
                  value={formik.values?.ibsRetidoNaFonte}
                  checked={formik.values?.ibsRetidoNaFonte}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={formik.values??.valorIbs === undefined}
                />
              }
              label="Retenção de IBS pelo cliente"
            />
          </Grid>
      
          <Grid item xs={12} sm={12} md={12} lg={1} xl={1}>
            <SelectSimple
              id="tipoCbs"
              label="Tipo"
              value={formik.values??.tipoCbs}
              fullWidth
              onChange={(event) => {
                formik.handleChange(event);
                formik.setFieldValue('valorCbs', undefined);
                formik.setFieldValue('cbsRetidoNaFonte', false);
              }}
              onBlur={formik.handleBlur}
              defaultValue="PERCENTUAL"
              options={[
                { title: '%', id: 'PERCENTUAL' },
                { title: 'R$', id: 'VALOR' },
              ]}
            />
          </Grid> */}
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
            {retencaoCbs(formik.values?.tipoCbs)}
          </Grid>
          {/* <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  id="cbsRetidoNaFonte"
                  name="cbsRetidoNaFonte"
                  value={formik.values?.cbsRetidoNaFonte}
                  checked={formik.values?.cbsRetidoNaFonte}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={formik.values??.valorCbs === undefined}
                />
              }
              label="Retenção de CBS pelo cliente"
            />
          </Grid>
      
          <Grid item xs={12} sm={12} md={12} lg={1} xl={1}>
            <SelectSimple
              id="tipoIs"
              label="Tipo"
              value={formik.values??.tipoIs}
              fullWidth
              onChange={(event) => {
                formik.handleChange(event);
                formik.setFieldValue('valorIs', undefined);
                formik.setFieldValue('isRetidoNaFonte', false);
              }}
              onBlur={formik.handleBlur}
              defaultValue="PERCENTUAL"
              options={[
                { title: '%', id: 'PERCENTUAL' },
                { title: 'R$', id: 'VALOR' },
              ]}
            />
          </Grid> */}
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            {retencaoIs(formik.values?.tipoIs)}
          </Grid>
          {/* <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  id="isRetidoNaFonte"
                  name="isRetidoNaFonte"
                  value={formik.values?.isRetidoNaFonte}
                  checked={formik.values?.isRetidoNaFonte}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={formik.values??.valorIs === undefined}
                />
              }
              label="Retenção de IS pelo cliente"
            />
          </Grid> */}
        </>
      )}
    </Grid>
  );
};

export default TabDadosFiscaisServico;
